module.exports = __webpack_public_path__ + "img/d1.82d2ed48.jpg";